var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("--vh: " + (_vm.W.h/100) + "px;")),attrs:{"id":"app"}},[_c('app-base'),(!_vm.isTouch)?_c('app-cursor'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }